import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimepickerComponent } from './timepicker.component';
import { TimepickerDirective } from './timepicker.directive';

@NgModule({
  declarations: [TimepickerDirective, TimepickerComponent],
  imports: [CommonModule],
  exports: [TimepickerDirective, TimepickerComponent]
})
export class SimTimepickerModule {}
